import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from "moment";

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

//Office Lease	Office Sale	Ind.Lease	Ind.Sale	Retail Lease	Retail Sale	Land Sale	Multi - Family		DB field
//1	2	3	4	5	6	7	8	yearQtr	leaseCommencementYear + '-' + leaseQuarter
//1	2	3	4	5	6	7	8	Submarket	submarket
//1		3		5				Tenant	tenant
//1	2	3	4	5	6		8	Building	buildingName
//1	2	3	4	5	6	7	8	Address	address
//1	2	3	4	5	6		8	SQFT	leasedSF
//1		3		5				Term	term
//1		3		5				Rate	effectiveRate
//1		3		5				Type	rateType
//1		3		5				T.I.TISF
//1		3		5				Type	transactionType
//7		Acres	acres
//2		4		6	7	8	SalePrice	salePrice
//2		4		6		8	PerSQFT	calculated
//2		4		6	7	8	Buyer	buyer
//2		4		6	7	8	Seller	seller


export class CompsList extends Component {
    static displayName = CompsList.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const isSearch = params.get('search');
        const active = params.get('active');
        const all = params.get('all');
        const compType = params.get('compType');
        const compsList =
            [
                { id: 1, name: "Office Lease" },
                { id: 2, name: "Office Sale" },
                { id: 3, name: "Industrial Lease" },
                { id: 4, name: "Industrial Sale" },
                { id: 5, name: "Retail Lease" },
                { id: 6, name: "Retail Sale" },
                { id: 7, name: "Land Sale" },
                { id: 8, name: "Multi-Family" }
            ];


        var compInfo = compsList.find(w => w.id == compType);
        if (!compInfo) {
            compInfo = { id: 0, name: "Invalid Comp Type" };
        }

        this.state = {
            compName: compInfo.name,
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            candidates: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            searchTerms: {},
            fromSearch: isSearch,
            fromActive: active,
            fromAll: all,
            searchOptions: {},
            compType: compType,
            compFieldOrder: [
                ['leaseCommencement', 'submarket16', 'tenant', 'buildingName', 'address', 'leasedSF', 'term', 'rate', 'rateType', 'TISF', 'leaseType'], //1
                ['leaseCommencement', 'submarket16', 'buildingName', 'address', 'sqft', 'salePrice', 'perSQFTBS', 'buyer', 'seller'], //2
                ['leaseCommencement', 'submarket16', 'tenant', 'buildingName', 'address', 'leasedSF', 'term', 'rate', 'rateType', 'TISF', 'leaseType'], //3
                ['leaseCommencement', 'submarket16', 'buildingName', 'address', 'sqft', 'salePrice', 'perSQFTBS', 'buyer', 'seller'], //4
                ['leaseCommencement', 'submarket16', 'tenant', 'buildingName', 'address', 'leasedSF', 'term', 'rate', 'rateType', 'TISF', 'leaseType'], //5
                ['leaseCommencement', 'submarket16', 'buildingName', 'address', 'sqft', 'salePrice', 'perSQFTBS', 'buyer', 'seller'], //6
                ['leaseCommencement', 'submarket16', 'address', 'acres', 'salePrice', 'buyer', 'seller'], //7
                ['leaseCommencement', 'submarket16', 'buildingName', 'address', 'sqft', 'salePrice', 'perSQFTBS', 'buyer', 'seller'] //8
            ],
            fieldCompTypes:
                [
                    {
                        fieldName: 'leaseCommencement',
                        validComp: [1, 3, 5],
                        varName: 'leaseCommencement',
                        inputType: "fromTo",
                        inputType: "fromTo",
                        label: "Year/QTR",
                        selectList: null
                    },
                    {
                        fieldName: 'dateSold',
                        validComp: [1, 3, 5],
                        varName: 'leaseCommencement',
                        inputType: "fromTo",
                        label: "Year/QTR",
                        selectList: null
                    },
                    {
                        fieldName: 'dateSold',
                        validComp: [2, 3, 5, 7, 8],
                        varName: 'dateSold',
                        inputType: "fromTo",
                        label: "Date Sold Year-Qtr [ex: 2010-2]",
                        selectList: null
                    },
                    {
                        fieldName: 'submarket16',
                        validComp: [1, 6],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: null
                    },
                    {
                        fieldName: 'submarket345',
                        validComp: [3, 4, 5],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: null
                    },
                    {
                        fieldName: 'submarket8',
                        validComp: [8],
                        varName: 'submarket',
                        inputType: "select",
                        label: "Submarket",
                        selectList: null
                    },
                    {
                        fieldName: 'tenant',
                        validComp: [1, 3, 5],
                        varName: 'tenant',
                        inputType: "input",
                        label: "Tenant",
                        selectList: null
                    },
                    {
                        fieldName: 'buildingName',
                        validComp: [1, 2, 3, 4, 5, 6],
                        varName: 'buildingName',
                        inputType: "input",
                        label: "Building",
                        selectList: null
                    },
                    {
                        fieldName: 'propertyName',
                        validComp: [8],
                        varName: 'buildingName',
                        inputType: "input",
                        label: "Property Name",
                        selectList: null
                    },
                    {
                        fieldName: 'address',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'address',
                        inputType: "input",
                        label: "Address",
                        selectList: null
                    },
                    {
                        fieldName: 'city',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'city',
                        inputType: "input",
                        label: "City",
                        selectList: null
                    },
                    {
                        fieldName: 'state',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'state',
                        inputType: "select",
                        label: "State",
                        selectList: null
                    },
                    {
                        fieldName: 'zip',
                        validComp: [1, 2, 3, 4, 5, 6, 7, 8],
                        varName: 'zip',
                        inputType: "input",
                        label: "Zip",
                        selectList: null
                    },
                    {
                        fieldName: 'leasedSF',
                        validComp: [1, 3, 5],
                        varName: 'leasedSF',
                        inputType: "decimal",
                        label: "SQFT",
                        selectList: null
                    },
                    {
                        fieldName: 'sqft',
                        validComp: [1, 3, 5],
                        varName: 'buildingSize',
                        inputType: "decimal",
                        label: "SQFT",
                        selectList: null
                    },
                    {
                        fieldName: 'term',
                        varName: 'term',
                        inputType: "decimal",
                        label: "Term",
                        selectList: null
                    },
                    {
                        fieldName: 'rate',
                        varName: 'effectiveRate',
                        inputType: "currency",
                        label: "Rate",
                        selectList: null
                    },
                    {
                        fieldName: 'leaseType',
                        validComp: [1, 3, 5],
                        varName: 'leaseType',
                        inputType: "select",
                        label: "Type",
                        selectList: null
                    },
                    {
                        fieldName: 'rateType',
                        validComp: [1, 3, 5],
                        varName: 'rateType',
                        inputType: "select",
                        label: "Type",
                        selectList: null
                    },
                    {
                        fieldName: 'TISF',
                        validComp: [1, 3, 5],
                        varName: 'tisf',
                        inputType: "currency",
                        label: "T.I.",
                        selectList: null
                    },
                    {
                        fieldName: 'buildingOwner',
                        validComp: [1, 3, 5],
                        varName: 'buildingOwner',
                        inputType: "input",
                        label: "Building Owner",
                        selectList: null
                    },
                    {
                        fieldName: 'buildingSize',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'buildingSize',
                        inputType: "decimal",
                        label: "Building Size",
                        selectList: null
                    },
                    {
                        fieldName: 'perSQFT',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'perSQFT',
                        inputType: "currency",
                        label: "Per SQFT",
                        selectList: null
                    },
                    {
                        fieldName: 'perSQFTBS',
                        validComp: [1, 2, 3, 5, 6, 8],
                        varName: 'perSQFTBS',
                        inputType: "currency",
                        label: "Per SQFT",
                        selectList: null
                    },
                    {
                        fieldName: 'yearBuilt',
                        validComp: [1, 2, 3, 4, 5, 6, 8],
                        varName: 'yearBuilt',
                        inputType: "fromTo",
                        label: "Year Built",
                        selectList: null
                    },
                    {
                        fieldName: 'buildingClass',
                        validComp: [1, 2, 3, 4],
                        varName: 'buildingClass',
                        inputType: "select",
                        label: "Building Class",
                        selectList: null
                    },
                    {
                        fieldName: 'tenantRepFirm',
                        validComp: [1, 3, 5],
                        varName: 'tenantRepFirm',
                        inputType: "input",
                        label: "Tenant Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'landlordRepFirm',
                        validComp: [1, 3, 5],
                        varName: 'landlordRepFirm',
                        inputType: "input",
                        label: "Landlord Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'buyer',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'buyer',
                        inputType: "input",
                        label: "Buyer",
                        selectList: null
                    },
                    {
                        fieldName: 'seller',
                        validComp: [2, 4, 6],
                        varName: 'seller',
                        inputType: "input",
                        label: "Seller",
                        selectList: null
                    },
                    {
                        fieldName: 'salePrice',
                        validComp: [2, 4, 6],
                        varName: 'salePrice',
                        inputType: "currency",
                        label: "Sale Price",
                        selectList: null
                    },
                    {
                        fieldName: 'acerage',
                        validComp: [2, 4, 6],
                        varName: 'acerage',
                        inputType: "fromTo",
                        label: "Acerage",
                        selectList: null
                    },
                    {
                        fieldName: 'saleType',
                        validComp: [2, 4, 6],
                        varName: 'saleType',
                        inputType: "select",
                        label: "Sale Type",
                        selectList: null
                    },
                    {
                        fieldName: 'buyerRepFirm',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'buyerRepFirm',
                        inputType: "input",
                        label: "Buyer Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'sellerRepFirm',
                        validComp: [2, 4, 6, 7, 8],
                        varName: 'sellerRepFirm',
                        inputType: "input",
                        label: "Seller Rep Firm",
                        selectList: null
                    },
                    {
                        fieldName: 'acres',
                        validComp: [7],
                        varName: 'acres',
                        inputType: "decimal",
                        label: "Acreage",
                        selectList: null
                    },
                    {
                        fieldName: 'propertyName',
                        validComp: [8],
                        varName: 'propertyName',
                        inputType: "input",
                        label: "Property Name",
                        selectList: null
                    },
                    {
                        fieldName: 'units',
                        validComp: [8],
                        varName: 'units',
                        inputType: "fromTo",
                        label: "Units",
                        selectList: null
                    }
                ],
        };
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isComps = false;
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isComps = await AdminFunctions.isRole("Comps");
            if (!isComps) {
                this.props.history.push('/login');
            }
        }
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //Default For reports
        this.setState({ searchOptions: { sstatus: 1 } });
        if (this.state.fromSearch === "1") {
            var data = JSON.parse(localStorage.getItem('compsSearchOptions'));
            this.setState({ searchOptions: data });
            this.SearchComps(data);
        } 
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ candidates: data });
    }


    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.candidates.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.candidates.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.candidates.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.candidates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            candidates: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.candidates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            candidates: data,
            sort: {
                column,
                direction
            }
        })
    }

    renderHeader() {
        let sortList = this.state.compFieldOrder[this.state.compType - 1];
        return sortList.map((fieldName) => {
            let field = this.state.fieldCompTypes.find((field) => field.fieldName == fieldName);
            if (field) {
                return (
                    <>
                        <th className="g-warm-gray-bg g-warm-gray-c tableHeader">
                            {field.label}
                            <FaSort
                                color={this.state.sort.column === field.varName ? '#0a58ca' : 'black'}
                                onClick={() => this.handleSort(field.varName)}
                                className='sort-button'
                            />
                        </th>
                    </>

                );
            } else {
                return ""
            }
            
        });
    }

    renderRow(comp) {
        let sortList = this.state.compFieldOrder[this.state.compType - 1];
        return sortList.map((fieldName) => {
            let field = this.state.fieldCompTypes.find((field) => field.fieldName == fieldName);

            if (field.varName == "perSQFT") {
                comp[field.varName] = comp.salePrice / comp.leasedSF;
            }
            if (field.varName == "perSQFTBS") {
                comp[field.varName] = comp.salePrice / comp.buildingSize;
            }
            if (field.varName == "perUnit") {
                comp[field.varName] = comp.salePrice / comp.units;
            }
            if (field.varName == "perAC") {
                comp[field.varName] = comp.salePrice / comp.acres;
            }
            if (field.varName == "perSQFTAC") {
                comp[field.varName] = comp.salePrice / (comp.acres * 43560);
            }
            if (field.varName == "acSQFT") {
                comp[field.varName] = comp.acres * 43560;
            }
            if (field && field.inputType == "currency") {
                return (
                    <>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{comp[field.varName] != null ? '$' + comp[field.varName].toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</td>
                    </>

                );
            } if (field && field.inputType == "decimal") {
                return (
                    <>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{comp[field.varName] != null ? comp[field.varName].toLocaleString() : ''}</td>
                    </>

                );
            } if (field && field.inputType == "date") {
                return (
                    <>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{moment(comp[field.varName], "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}</td>
                    </>

                );
            } else if (field) {
                return (
                    <>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{comp[field.varName]}</td>
                    </>

                );
            } else {
                return ""
            }
            
        });
    }

    render() {

        // Logic for displaying candidates
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.candidates.slice(indexOfFirstItem, indexOfLastItem);

        const renderItems = currentItems.map((comp, i) => {
            return (
                <tr key={i}>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        <NavLink className="noNavLink"
                            tag={Link}
                            to={'/Comps/CompSummary?compId=' + comp.id + '&compType=' + this.state.compType}
                        >
                            view
                        </NavLink>
                    </td>
                    {this.renderRow(comp) }
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.candidates.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <div>
                <Container>


                    <Row>
                        <Col style={{ textAlign: 'center' }} >
                            <div id="head">
                                <h3 style={{ textAlign: 'center' }}>Search Results: {this.state.compName}</h3>
                            </div>
                            <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px", width: "unset" }} onClick={() => {
                                this.PrintComps();
                            }} >Comps Report</button>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '20px' }}>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-light-gray-c">

                                        </th>
                                        {this.renderHeader()}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <>
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <Spinner color="primary" children='' />
                                                </td>
                                            </tr>
                                        </>


                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                    <tr className="noBorderColor">
                                                        <td className="noBorderColor count" colSpan="9" >
                                                            <label className="textLabel">Count:</label> {this.state.candidates.length}
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    async GetActiveLeases(status) {
        this.setState({ loading: true, loadingDocument: false });
        const token = Session.getToken();
        const response = await fetch('api/Leases/ShowAllLeases?status=' + status, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        const data = await response.json();
        this.setState({ candidates: data, loading: false, noResults: data.length === 0 ? true : false });
    }

    //async GetReport(reportName) {
    //    this.setState({ loadingDocument: true });
    //    const token = Session.getToken();
    //    const response = await fetch('api/Leases/GetReport?reportName=' + reportName, {
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    //    })
    //    const data = await response.json();
    //    this.setState({ loadingDocument: false });
    //    this.downloadFile(data.documentBase64, reportName);
    //}

    async GetReport(reportName) {
        try {
            this.setState({ loadingDocument: true });
            const token = Session.getToken();
            var search = {};
            if (this.state.searchOptions) {
                search = this.state.searchOptions;
            }


            search.reportName = reportName;
            if (!search.soffice_number) {
                search.soffice_number = null;
            };
            if (!search.s_type) {
                search.s_type = null;
            };
            if (!search.sbuilding_name) {
                search.sbuilding_name = null;
            };
            if (!search.saddress) {
                search.saddress = null;
            };
            if (!search.scity) {
                search.scity = null;
            };
            if (!search.sstate) {
                search.sstate = null;
            };
            if (!search.szip) {
                search.szip = null;
            };
            if (!search.sced) {
                search.sced = null;
            };
            if (!search.scede) {
                search.scede = null;
            };
            if (!search.sstatus) {
                search.sstatus = null;
            };

            console.log("Before string");
            var stringified = JSON.stringify(search);
            console.log("After string");
            console.log("String: " + stringified);
            const response = await fetch('api/Leases/GetReport', {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(search)
            });
            console.log("After response");
            const data = await response.json();
            console.log("After response.json");
            console.log("Response Json: " + data);
            this.setState({ loadingDocument: false });
            console.log("After loadingDocument");
            this.downloadFile(data.documentBase64, reportName);
        } catch (ex) {
            this.setState({ loadingDocument: false });
            console.log("Error: ");
            console.log(ex);
            throw ex;
        }
    }

    downloadFile(file, name) {
        const blob = this.base64ToBlob(file);
        const uriContent = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', uriContent);
        link.setAttribute('download', name);
        const event = new MouseEvent('click');
        link.dispatchEvent(event);
    }

    base64ToBlob = (file) => {
        const binaryString = window.atob(file);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; ++i) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
    }

    async SearchComps(searchOptions) {
        /*this.setState({ loading: true, loadingDocument: false });*/
        const token = Session.getToken();
        searchOptions.compType = this.state.compType;
        const response = await fetch('api/Comps/SearchComps', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(searchOptions)
        });
        const data = await response.json();
        this.setState({ candidates: data, loading: false, noResults: data.length === 0 ? true : false });
        //const data = await response.json();
        //this.setState({ lease: data });
    }

    async PrintComps() {
        /*this.setState({ loading: true, loadingDocument: false });*/
        const token = Session.getToken();
        const response = await fetch('api/Comps/GetReport', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.candidates)
        });
        console.log("After response");
        const data = await response.json();
        console.log("After response.json");
        console.log("Response Json: " + data);
        this.setState({ loadingDocument: false });
        console.log("After loadingDocument");
        this.downloadFile(data.documentBase64, this.state.compName + " Comps" + new Date().toISOString().substring(0, 10));
        //const data = await response.json();
        //this.setState({ lease: data });
    }
}

